import React from 'react';
// import orange from '@mui/material/colors/orange';
import { useAuthMethod, useAuthUser } from '../../../../utility/AuthHooks';
import { Box } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Fonts } from 'shared/constants/AppEnums';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useLayoutContext } from '@crema/utility/AppContextProvider/LayoutContextProvider';
import AppTooltip from '@crema/core/AppTooltip';
import { stringAvatar } from 'shared/constants/AppEnums';
import { API } from 'shared/constants/AppEnums';
import { useDispatch } from 'react-redux';
import { toggleNavCollapsed } from 'redux/actions';
import { useSelector } from 'react-redux';

const UserInfo = ({ color }) => {
  const { user } = useAuthUser();
  const navigate = useNavigate();
  const { isiPad } = useLayoutContext();
  const { logoutPortal } = useAuthMethod();
  const dispatch = useDispatch()
  const navCollapsed = useSelector(({ settings }) => settings.navCollapsed);
  const isRoleMenu = user.roles_coofis.some(item => item.state === 'CUSTOM_MENU')
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    // if (isiPad && !navCollapsed) return;
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const getAvatar = (link) => {
    return API.BASE_URL_AVATAR + link;
  };

  return (
    <>
      <Box
        onClick={handleClick}
        sx={{
          py: 2,
          px: 2,
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
        }}
        className='user-info-view'
      >
        <Box sx={{ py: 0.5 }}>
          <Avatar
            {...stringAvatar(user?.displayName)}
            src={getAvatar(user?.avatar_signed)}
          />
        </Box>
        <Box
          sx={{
            width: { xs: 'calc(100% - 62px)', xl: 'calc(100% - 72px)' },
            ml: 4,
            color: color,
          }}
          className='user-info'
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Box
              sx={{
                mb: 0,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                fontSize: 16,
                fontWeight: Fonts.MEDIUM,
                color: 'inherit',
              }}
              component='span'
            >
              {user?.displayName ? user?.displayName : 'Admin User '}
            </Box>
            <Box
              sx={{
                ml: 3,
                color: 'inherit',
                display: 'flex',
              }}
            >
              <ExpandMoreIcon />
            </Box>
          </Box>
          <AppTooltip placement='right' title={user?.nama_jabatan}>
            <Box
              sx={{
                mt: -0.5,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                color: 'inherit',
              }}
            >
              {user?.nama_jabatan}
            </Box>
          </AppTooltip>
        </Box>
      </Box>
      <Menu
        id='simple-menu'
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem
          onClick={() => {
            navigate('/profile');
            handleClose();
            if (navCollapsed) {
              dispatch(toggleNavCollapsed())
            }
          }}
        >
          Profil
        </MenuItem>

        <MenuItem
          onClick={() => {
            navigate('/faq');
            handleClose();
            if (navCollapsed) {
              dispatch(toggleNavCollapsed())
            }
          }}
        >
          FAQ
        </MenuItem>

        {
          isRoleMenu &&
          <MenuItem
            onClick={() => {
              navigate('/pengaturan-menu')
              if (navCollapsed) {
                dispatch(toggleNavCollapsed())
              }
            }}
          >
            Pengaturan Menu
          </MenuItem>
        }

        <MenuItem onClick={logoutPortal}>Logout</MenuItem>
      </Menu>
    </>
  );
};

export default UserInfo;

UserInfo.defaultProps = {
  color: 'text.secondary',
};

UserInfo.propTypes = {
  color: PropTypes.string,
};
